module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kegQg"))).then(() => parcelRequire('37nVf'));